// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1X4jX","savePackageButton":"ClientWallet_savePackageButton__3MbRR"};